import { PageResponseVm } from 'api/core/page-response.vm';
import { Type } from 'class-transformer';
import { IsString, ValidateNested } from 'class-validator';
import { ReplenishmentThresholdVm } from './replenishment-threshold.vm';

export class GetReplenishmentThresholdsVm extends PageResponseVm<ReplenishmentThresholdVm, string> {
  @IsString()
  nextOffset: string | null;

  @ValidateNested({ each: true })
  @Type(() => ReplenishmentThresholdVm)
  objects: ReplenishmentThresholdVm[];
}
